import store from "../store";

export default {
  install(Vue) {
    Vue.prototype.$isCreditOnline = () => {
      if (store.state.operators.credit == 2) {
        return true
      } else {
        return false
      }
    }
    Vue.prototype.$isRetailSimplifiedOnly = () => {
      if (store.state.operators.credit == 0 && store.state.operators.retail == 1) {
        return true
      } else {
        return false
      }
    }
    // Use to create resume on Historic bets listBets
    Vue.prototype.$resume = {
      resumeBet: function (data) {
        let resume = data
        let resumeBet = {
          prizeTotal: "",
          amountTotal: "",
          prizeNoPaid: "",
          prizePaid: "",
        }
        // Resume
        const listPrize = [];
        const listAmount = [];
        const listPrizePaid = [];
        const prizeNoPaid = [];

        resume.forEach((value) => {
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;

          listPrize.push(Number(value.prize));

          resumeBet.prizeTotal = listPrize.reduce(reducer).toFixed(2);
          listAmount.push(Number(value.amount));
          resumeBet.amountTotal = listAmount.reduce(reducer).toFixed(2);
          if (value.paid == "1") {
            listPrizePaid.push(Number(value.prize));
            resumeBet.prizePaid = listPrizePaid
              .reduce(reducer).toFixed(2);

          } else {
            prizeNoPaid.push(Number(value.prize));
            resumeBet.prizeNoPaid = prizeNoPaid
              .reduce(reducer).toFixed(2);

          }
        });

        return resumeBet
      }
    }
  }
}